import React from 'react';
import { Link } from 'react-router-dom';

import './style.css';
import { PulseLoader } from 'react-spinners';

const Button = ({
  className = '',
  link,
  id,
  type,
  onClick,
  children,
  loading,
  variant = 'primary',
  size = 'medium',
  icon,
  iconPosition = 'left',
  disabled,
}) => {
  const buttonClasses = `btn btn-${variant} btn-${size} ${className}`;

  const renderContent = () => {
    if (loading) {
      return <PulseLoader color="#ffffff" size={10} />;
    }

    return (
      <span className="btn-content">
        {icon && iconPosition === 'left' && (
          <span className="btn-icon btn-icon-left">{icon}</span>
        )}
        {children && <span className="btn-text">{children}</span>}
        {icon && iconPosition === 'right' && (
          <span className="btn-icon btn-icon-right">{icon}</span>
        )}
      </span>
    );
  };

  return (
    <div className={`button ${className}`}>
      {link === undefined ? (
        <button
          id={id}
          className={buttonClasses}
          type={type}
          onClick={onClick}
          disabled={loading || disabled}
        >
          {renderContent()}
        </button>
      ) : (
        <Link to={link} id={id} className={buttonClasses} onClick={onClick}>
          {renderContent()}
        </Link>
      )}
    </div>
  );
};

export default Button;
